<template>
  <v-app>
    <ImageTransferApp/>
  </v-app>
</template>

<script>

import ImageTransferApp from '@/views/ImageTransferApp'

export default {
  name: 'App',
  components: {
    ImageTransferApp
  },
  data () {
    return {
      //
    }
  }
}
</script>
